import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Serwis przechowujący globalny format daty.
 * Używany przez DateFormatterComponent i wszędzie gdzie potrzebny jest ujednolicony format.
 */
@Injectable({ providedIn: 'root' })
export class DateFormatService {
  private readonly DEFAULT_FORMAT = 'dd.MM.yyyy';
  private _format$ = new BehaviorSubject<string>(this.DEFAULT_FORMAT);

  /** Aktualny format jako Observable */
  public format$: Observable<string> = this._format$.asObservable();

  /** Aktualny format (synchronicznie) */
  get format(): string {
    return this._format$.value;
  }

  /** Ustawia nowy format daty */
  setFormat(format: string): void {
    if (format && format !== this._format$.value) {
      this._format$.next(format);
    }
  }
}
